import rest from '@modules/rest'
import { mapEmployeeCustomFields } from '@convenia/common-organisms/SystemFields/helpers'

export async function getEmployeeInfoSchema ({ employeeId, companyId, area } = {}) {
  try {
    const params = { area }
    const url = `/companies/proxy/companies/${companyId}/employees/${employeeId}/fields/employee`

    const { data } = await rest.get(url, { params })

    const { fields } = data || {}

    const mappedFields = mapEmployeeCustomFields(fields || [], 'employee')

    return [ null, mappedFields ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getRequiredSystemFields = async ({ companyId }) => {
  try {
    const url = `/companies/proxy/companies/${companyId}/system-fields/mandatories/employee`

    const { data } = await rest.get(url)

    return [ null, data ]
  } catch (err) {
    return [ err, [] ]
  }
}
